import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Tooltip from "@material-ui/core/Tooltip";
import Help from "@material-ui/icons/Help";

import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";

import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/components/royaltyRowStyle.js";
const useStyles = makeStyles(styles);

// Linha label/valor do fechamento de royalties, com tooltip "?" e subtexto opcionais.
export default function RoyaltyRow({ label, value, help, sub, tone, size, highlight, children }) {
    const classes = useStyles();

    const rowClasses = classNames(classes.row, {
        [classes.highlight]: highlight === true,
        [classes.highlightPositive]: highlight === "positive",
        [classes.highlightNegative]: highlight === "negative"
    });

    const valueClasses = classNames(classes.value, {
        [classes.emphasis]: size === "emphasis",
        [classes.large]: size === "large",
        [classes.positive]: tone === "positive",
        [classes.negative]: tone === "negative"
    });

    return (
        <GridContainer className={rowClasses}>
            <GridItem xs={12} sm={6} md={6}>
                <div className={classes.label}>
                    {label}:
                    {help &&
                        <Tooltip title={help} placement="top">
                            <Help className="question" />
                        </Tooltip>
                    }
                </div>
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
                {children ? children : <span className={valueClasses}>{value}</span>}
                {sub && <span className={classes.sub}>{sub}</span>}
            </GridItem>
        </GridContainer>
    );
}

RoyaltyRow.propTypes = {
    label: PropTypes.node.isRequired,
    value: PropTypes.node,
    help: PropTypes.node,
    sub: PropTypes.node,
    tone: PropTypes.oneOf(["positive", "negative", "neutral"]),
    size: PropTypes.oneOf(["emphasis", "large"]),
    highlight: PropTypes.oneOf([true, false, "positive", "negative"]),
    children: PropTypes.node
};

export function RoyaltyGroupTitle({ children }) {
    const classes = useStyles();
    return <div className={classes.groupTitle}>{children}</div>;
}

RoyaltyGroupTitle.propTypes = {
    children: PropTypes.node
};
